<template>
  <section v-if="data.items && data.items.length" class="l-container">
    <div class="shop-container">
      <UiHorizontalScroll class="shops">
        <nuxt-link
          v-for="(shop, index) in shopList"
          :key="index"
          :to="`/${shop.coupons_slug}/`"
          class="shop"
        >
          <img
            v-if="shop.logo"
            class="image"
            :src="shop.logo"
            :alt="shop.name"
            :title="shop.title"
          />
          <span v-else class="without-image">
            {{ shop.name }}
          </span>
        </nuxt-link>
      </UiHorizontalScroll>
      <ui-ui-link
        icon-after="right"
        :font-weight="400"
        mode="link"
        path="/magaziny/"
      >
        {{ isMobile ? 'Все' : 'Все магазины' }}
      </ui-ui-link>
    </div>
  </section>
</template>

<script setup lang="ts">
import type { ShopsPopularContent } from '~/interfaces/constructor';
import { useMediaQueryStore } from '~/stores/mediaQuery';
const mediaStore = useMediaQueryStore();
const props = defineProps({
  data: {
    required: true,
    type: Object as () => ShopsPopularContent,
  },
});

const isMobile = computed(
  () =>
    mediaStore.isMobile ||
    mediaStore.isLessEs ||
    mediaStore.isEs ||
    mediaStore.isSm ||
    mediaStore.isMd
);

const shopList = computed(() => {
  return isMobile.value ? props.data.items : props.data.items?.slice(0, 11);
});
</script>
<style lang="scss" src="./ShopsPopularScss.scss" scoped></style>
